export type Interval = 'day' | 'hour' | 'minute'

export interface StatsFilters {
    eventIds: number[]
    devices: string[]
    dateFrom: string | null
    dateTo: string | null
    interval: Interval | null
    showEmptyTicketsets: boolean
}

export interface PreparedStatsArgs {
    eventIds?: number[]
    devices?: string[]
    dateFrom?: string
    dateTo?: string
    interval?: 'DAY' | 'HOUR' | 'MINUTE'
    showEmptyTicketsets: boolean
}

export function prepareArgs(f: StatsFilters): PreparedStatsArgs {
    // Coerce eventIds to numbers — PrimeVue MultiSelect emits option values
    // as strings even when the underlying option-value is numeric. Backend
    // `eventIds: [Int]` rejects string values.
    const eventIds = f.eventIds.length > 0 ? f.eventIds.map(v => Number(v)).filter(n => Number.isFinite(n)) : undefined
    return {
        eventIds: eventIds && eventIds.length > 0 ? eventIds : undefined,
        devices: f.devices.length > 0 ? f.devices : undefined,
        dateFrom: f.dateFrom || undefined,
        dateTo: f.dateTo || undefined,
        interval: f.interval ? (f.interval.toUpperCase() as 'DAY' | 'HOUR' | 'MINUTE') : undefined,
        showEmptyTicketsets: f.showEmptyTicketsets
    }
}

export function defaultFilters(): StatsFilters {
    return {
        eventIds: [],
        devices: [],
        dateFrom: null,
        dateTo: null,
        interval: null,
        showEmptyTicketsets: false
    }
}
